module.exports = __webpack_public_path__ + "static/media/contact.0f5aa072.png";